import Vue from "vue";
import VueI18n from "vue-i18n";
import { getLocale, registerLocalTranslations } from "@defa-as/utils";

Vue.use(VueI18n);

registerLocalTranslations({
  nb: () => import("./locales/nb.json"),
  sv: () => import("./locales/sv.json"),
  fi: () => import("./locales/fi.json"),
  da: () => import("./locales/da.json"),
});

export default new VueI18n({
  locale: getLocale(),
  fallbackLocale: "nb",
});
